import { render, staticRenderFns } from "./Research.vue?vue&type=template&id=721fe454&scoped=true&"
import script from "./Research.vue?vue&type=script&lang=js&"
export * from "./Research.vue?vue&type=script&lang=js&"
import style0 from "./Research.vue?vue&type=style&index=0&id=721fe454&scoped=true&lang=css&"
import style1 from "./Research.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721fe454",
  null
  
)

export default component.exports